// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"53a832a4","554":"2228673f","629":"b2e7ab65","912":"54fea45e"}[chunkId] + ".chunk.js";
};